import Role from "./Role";

/**
 * Represents a user and their associated role in a business or entity context.
 */
class RoleUser {

  user_id: string;
  role_id: number;
  entity_id: number;
  business_name: string | null;
  created_at: string | null;
  updated_at: string | null;
  role: Role;
  system: string | null;
  constructor(
    user_id: string,
    role_id: number,
    entity_id: number,
    business_name: string | null,
    created_at: string | null,
    updated_at: string | null,
    role: Role,
    system: string
  ) {
    this.user_id = user_id;
    this.role_id = role_id;
    this.entity_id = entity_id;
    this.business_name = business_name;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.role = role;
    this.system = system;
  }

  /**
   * Converts a JSON object into an instance of the RoleUser class.
   *
   * @param {any} item - The JSON object containing the data to create a RoleUser instance.
   * @return {RoleUser} A new instance of the RoleUser class populated with the data from the JSON object.
   */
  public static fromJson(item: any): RoleUser {
    return new RoleUser(
      item.user_id,
      item.role_id,
      item.entity_id,
      item.business_name,
      item.created_at,
      item.updated_at,
      Role.fromJson(item.role),
      item.system ?? null
    )
  }

  /**
   * Gets the user's unique identifier
   * @returns The user's ID
   */
  getUserId(): string {
    return this.user_id;
  }

  /**
   * Gets the role's numeric identifier
   * @returns The role's ID
   */
  getRoleId(): number {
    return this.role_id;
  }

  /**
   * Gets the entity's numeric identifier
   * @returns The entity's ID
   */
  getEntityId(): number {
    return this.entity_id;
  }

  /**
   * Gets the business name
   * @returns The business name or null if not applicable
   */
  getBusinessName(): string | null {
    return this.business_name;
  }

  /**
   * Gets the creation timestamp
   * @returns The creation timestamp or null if not available
   */
  getCreatedAt(): string | null {
    return this.created_at;
  }

  /**
   * Gets the last update timestamp
   * @returns The last update timestamp or null if not available
   */
  getUpdatedAt(): string | null {
    return this.updated_at;
  }

  /**
   * Gets the associated role
   * @returns The Role object
   */
  getRole(): Role {
    return this.role;
  }

  getSystem(): string | null {
    return this.system;
  }
}

export default RoleUser;